<template>
  <div class="app-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppLayout'
}
</script>

<style lang="scss">
.app-layout {
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  background-color: $background-color;

  &__header {
    position: fixed;
    z-index: 1024;
    top: 0;
    left: 0;
    width: 100%;
    height: $nav-height;
    transform: translateZ(0);
  }

  &__body {
    display: flex;
    flex: 1;
    padding-top: $nav-height;
  }

  &__footer {
    padding: 30px 0 20px;
  }
}
</style>
